import type { ComponentType } from 'react';

import type { LoadableComponent } from 'react-loadable';
import type {
	Route,
	RouteContext,
	RouterContext,
	RouteResources,
} from 'react-resource-router-next';

import type { NullableEntryPoint } from '@atlassian/react-entrypoint';

type BaseRoute = Route & {
	hideAskRovoSidebar?: boolean;
	hideSideNav?: boolean;
	hideSiteSwitcher?: boolean;
	resources?: RouteResources;
	skeleton?: () => Promise<{ default: ComponentType<unknown> }>;
	trackerName?: string;
};

export type LoadableRoute = Omit<BaseRoute, 'component'> & {
	component?: ComponentType<RouteContext> & LoadableComponent;
	entryPoint?: never;
};

export type EntryPointRoute = Omit<BaseRoute, 'component'> & {
	entryPoint: () => NullableEntryPoint<any, { context: RouterContext }> | undefined;
};

export const isEntryPointRoute = (route: StudioRoute): route is EntryPointRoute => {
	return !!route.entryPoint && typeof route.entryPoint === 'function';
};

export type ComponentRoute = BaseRoute & {
	entryPoint?: never;
};

export type StudioRoute = LoadableRoute | EntryPointRoute | ComponentRoute;
